import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { headerIconButtonClass } from "./headerButton";
import { HeaderTip } from "./HeaderTip";
import { AI_CHAT_STATUS_EVENT, toggleAiChat, type AiChatStatus } from "@/components/specific/ai/chatConstants";

export const AskVectaButton = () => {
  const [replying, setReplying] = useState(false);

  useEffect(() => {
    const handleStatus = (event: Event) => setReplying((event as CustomEvent<AiChatStatus>).detail.replying);
    window.addEventListener(AI_CHAT_STATUS_EVENT, handleStatus);
    return () => window.removeEventListener(AI_CHAT_STATUS_EVENT, handleStatus);
  }, []);

  return (
    <HeaderTip label={replying ? "Ask Vecta (replying)" : "Ask Vecta"}>
    <button
      type="button"
      onClick={toggleAiChat}
      aria-label={replying ? "Ask Vecta, replying" : "Ask Vecta"}
      className={headerIconButtonClass}
    >
      <Sparkles className="size-4.5" fill="currentColor" aria-hidden="true" />
      {replying ? (
        <>
          <span
            aria-hidden="true"
            className="absolute -top-1 -right-1 size-2.5 animate-pulse rounded-full bg-amber-400 ring-2 ring-(--layout-brand)"
          />
          <span className="sr-only">Vecta is replying</span>
        </>
      ) : null}
    </button>
    </HeaderTip>
  );
};
